import { render } from "./alert.vue?vue&type=template&id=7ac4a57d"
import script from "./alert.vue?vue&type=script&lang=js"
export * from "./alert.vue?vue&type=script&lang=js"

import exportComponent from "../../../../CPSDashApontamento/apontamentowebvueV3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__